const defaultStyles = {
  root: {
    position: 'relative',
    paddingBottom: '0px',
    width: '100%'
  },

  autocompleteContainer: {
    position: 'absolute',
    top: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid #e6e6e6',
    width: '100%'
  },

  autocompleteItem: {
    backgroundColor: '#ffffff',
    padding: '5px 10px',
    color: '#616161',
    cursor: 'pointer'
  },

  autocompleteItemActive: {
    backgroundColor: '#fafafa'
  }
};

export default defaultStyles;



// WEBPACK FOOTER //
// ./src/components/AddressAutocomplete/defaultStyles.js